var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnHtml)?_c('base-section',{attrs:{"id":"pro-features"}},[_c('base-section-heading',{attrs:{"title":_vm.$i18n.t(_vm.heading)}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.btnHtml)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }